export enum StoryblokVersion {
    Published = 'published',
    Draft = 'draft'
}

/**
 * Storyblok Stories which are located in a folder with this prefix in their
 * slug should be hidden and not used within out application.
 */
export const StoryblokSlugPrefixToHide = 'h__';

export enum StoryblokStaticSlugs {
    GlobalConfigs = 'h__global_configs',
    Redirects = 'h__global_configs/redirects',
    GlobalCountryConfig = 'h__global_configs/globalcountryconfig',
    Translations = 'h__global_configs/translations',
    AccountBonus = '/account/bonus'
}

export const StoryblokProxyEndpoint = '/api/storyblok-proxy';
